import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './LoginPage';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import UploaderRoute from './auth/UploaderRoute';
// Dashboard disabled - kept as Dashboard.jsx.bak; use KpiDashboard instead
import UserManagement from './pages/UserManagement';
import SourceConfig from './pages/SourceConfig';
import ActivityLog from './pages/ActivityLog';
import KpiDashboard from './pages/KpiDashboard';
import FileUploadPage from './pages/FileUploadPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          {/* Uploader-only route */}
          <Route element={<UploaderRoute />}>
            <Route path="/upload" element={<FileUploadPage />} />
          </Route>
          {/* Standard authenticated routes (not accessible to uploader-only role) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Navigate to="/kpi-dashboard" replace />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/source-config" element={<SourceConfig />} />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="/kpi-dashboard" element={<KpiDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

